import { Accordion } from "@mantine/core";

import AccordionStyles from "./Accordion.module.css";

export const accordionOverrides = {
  Accordion: Accordion.extend({
    defaultProps: {
      // The chevron is decorative (the control's aria-expanded already
      // conveys state) but renders an unnamed <svg> (WCAG 1.1.1,
      // svg_graphics_labelled). Same pattern as NavLink.config.ts.
      attributes: {
        chevron: { "aria-hidden": true },
      },
    },
    classNames: {
      control: AccordionStyles.control,
      label: AccordionStyles.label,
      item: AccordionStyles.item,
      content: AccordionStyles.content,
      chevron: AccordionStyles.chevron,
      panel: AccordionStyles.panel,
    },
  }),
};
